export default "__VITE_ASSET__Dd0HjQN2__"